var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0598 5.50005C23.0598 7.83192 21.1695 9.72228 18.8376 9.72228C16.5057 9.72228 14.6154 7.83192 14.6154 5.50005C14.6154 3.16819 16.5057 1.27783 18.8376 1.27783C21.1695 1.27783 23.0598 3.16819 23.0598 5.50005Z",
    stroke: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11111 13.6854C9.11111 16.0172 7.22076 17.9076 4.88889 17.9076C2.55702 17.9076 0.666668 16.0172 0.666668 13.6854C0.666668 11.3535 2.55702 9.46313 4.88889 9.46313C7.22076 9.46313 9.11111 11.3535 9.11111 13.6854Z",
    stroke: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0598 21.8704C23.0598 24.2023 21.1695 26.0926 18.8376 26.0926C16.5057 26.0926 14.6154 24.2023 14.6154 21.8704C14.6154 19.5385 16.5057 17.6482 18.8376 17.6482C21.1695 17.6482 23.0598 19.5385 23.0598 21.8704Z",
    stroke: "#ACACAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2778 6.44458L7.72222 11.1668",
    stroke: "#ACACAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8591 19.6038L8.66666 15.8889",
    stroke: "#ACACAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGrey);
export default __webpack_public_path__ + "static/media/share-grey.72203c143abb7fe280dbd55570f0f172.svg";
export { ForwardRef as ReactComponent };